import * as React from "react"

import { USER_ROLE, VISIBILITY_TRACKER_ROUTES } from "@constants"
import AppLayout from "Layout"
import AiCostsPage from "./index"


export const VtAiCostsRoutes = {
	path: VISIBILITY_TRACKER_ROUTES.AI_COSTS_PATH,
	title: VISIBILITY_TRACKER_ROUTES.AI_COSTS_TITLE,
	icon: 'sack-dollar',
	iconWeight: 'light',
	element: <AppLayout />,
	description: 'OpenAI token and cost tracking across retailers, sections and element kinds',
	access: USER_ROLE.ADMIN,
	children: [{
		element: <AiCostsPage />,
		index: true
	}]
}
